export default __webpack_public_path__ + "static/ethereum-d39620bd012576efc5450d5db3b9ed74.svg";